import {
  Model,
} from '@vuex-orm/core';

export default class extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'feed'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.number(0),
      hash: this.string(''),
      profile_id: this.number(0),
      name: this.string(''),
      enabled: this.number(0),
      feed_rules_count: this.number(0),
      posts_count: this.number(0),
      channels_count: this.number(0),
      last_search_performed_at: this.string(''),
      last_fetch_performed_at: this.string(''),
      last_tag_generation_performed_at: this.string(''),
      created_at: this.string(''),
      updated_at: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: process.env.VUE_APP_APIS_FETCHER_ADMIN,
    },
    methods: {
      $fetch: {
        name: 'fetch',
        http: {
          url: '/feeds',
          method: 'get',
        },
      },
      $get: {
        name: 'get',
        http: {
          url: '/feeds/:id',
          method: 'get',
        },
      },
      $create: {
        name: 'create',
        http: {
          url: '/feeds',
          method: 'post',
        },
      },
      $update: {
        name: 'update',
        http: {
          url: '/feeds/:id',
          method: 'put',
        },
      },
      $delete: {
        name: 'delete',
        http: {
          url: '/feeds/:id',
          method: 'delete',
        },
      },
    },
  }
}
